<!-- 学员的框架页 -->
<template>
    <div class="app-student" :class="appThemeClass" id="app-student">
        <div class="app-student-header">
            <app-header
                height="64px"
                :title="title">
            </app-header>
        </div>

        <nav class="app-student-nav">
            <div class="nav-inner layout">
                <div class="menu-list">
                    <router-link v-for="item in menuData" :to="item.path" :key="item.id">{{item.name}}</router-link>
                </div>

                <!-- 主题切换 -->
                <el-popover
                    class="operate-btn changeTheme"
                    trigger="click"
                >
                    <div style="display: flex;flex-wrap: wrap;">
                        <div v-for="(theme, index) in [
                            ['#282828', '#33363d'],
                            ['#00bcd4', '#1b6b83'],
                            ['#053f5e', '#115173'],
                            ['#393e46', '#445065'],
                            ['#3C8DBC', '#367FA9']]"
                             style="width: 60px;height: 60px;margin-right:10px;cursor: pointer">
                            <p v-for="item in theme" @click="changeTheme(index)"
                               style="height: 50%" :style="{backgroundColor: item}"></p>
                        </div>
                    </div>
                    <span slot="reference" class="operate-btn changeTheme" :title="$t('app.switchTheme')">
                <i class="nucfont inuc-alter"></i>
            </span>
                </el-popover>
            </div>
        </nav>

        <div class="app-student-main">
            <div class="app-student-scroll">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import appHeader from '@/components/App/AppHeader.vue';
    import {mapGetters} from 'vuex';
    import {Ticket, Storage} from '@/utils';
    import {FullAlert} from '@/plugins/fullscreenAlert'

    export default {
        props: {
            title: String
        },

        components: {
            appHeader
        },

        data() {
            return {
                menuData: {},
            }
        },

        computed: {
            //theme: 0新版暗色、1经典
            ...mapGetters([
                'appTheme',
                'wsTrainee',
            ]),
            appThemeClass() {
                return ['app-theme1', 'app-theme2', 'app-theme3', 'app-theme4', 'app-theme5'][this.appTheme]
            },
        },

        created() {
            this.menuData = Storage.get('menu');

            // 学员菜单要是有一个父级菜单，做此兼容
            if (this.menuData[0].children.length) {
                this.menuData = this.menuData[0].children;
            }

            Ticket.get() && this.$store.commit('initAppTheme')
        },

        mounted() {
            this.checkLayout()
            window.addEventListener('resize', this.checkLayout, false)

            // 初始化学员端的signalR
            this.initWSMessage()
        },

        methods: {
            changeTheme(theme) {
                this.$store.dispatch('updateAppTheme', theme)
            },

            checkLayout() {
                let h = $('.app-student-nav').height() + 64
                $('.app-student-main').css('paddingTop', `${h}px`)
            },

            initWSMessage() {
                this.$store.dispatch('startWSTrainee').then(() => {
                    this.wsTrainee.on('RMessage', (id, name, message) => {
                        console.log(id, name, message)

                        let hasAlertNow = $('.fullscreen-alert:visible').length
                        if (hasAlertNow) return

                        // 监考消息
                        if (message) {
                            this.showAlert({
                                id,
                                message,
                                title: '监考消息',
                            })

                            // 弹窗打卡消息
                        } else {
                            this.showAlert({
                                id,
                                message: `收到来自${name}的弹窗打卡消息`,
                                title: '弹窗打卡',
                                confirmButtonText: '打卡'
                            })
                        }
                    })
                })
            },

            showAlert({
                id = '',
                message = '',
                title = '',
                confirmButtonText = '确定'
            }={}) {
                FullAlert(message, title, {
                    type: 'warning',
                    confirmButtonText,
                    showClose: false,
                    customClass: 'wsTraineeAlert',
                    callback: (action, el) => {
                        this.wsTrainee.send('SFeedback', id, '')
                        let $modal = $(el.$el).next('.v-modal')
                        if ($modal.length) {
                            $modal.remove()
                        }
                    }
                })
            },
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.checkLayout, false)
            this.$store.commit('stopWSTrainee')
        },
    }
</script>

<style lang="scss">
    @import '../../style/const';
    @include scrollbar(#777, 10px);

    .app-student {
        height: 100%;

        .layout {
            width: 75%;
            min-width: 1200px;
            margin: 0 auto;
            @media screen and (max-width: 1280px) {
                min-width: 960px;
            }
        }
    }

    /**
        目前学员header和header组件样式高度重合
        只需对封装好的header组件的样式进行更改
     */
    .app-student-header {
        position: fixed;
        z-index: 8;
        width: 100%;

        .app-header {
            position: static;
            padding: 0;
            @extend .layout;
        }

        .header-logo {
            margin-left: 20px;
            margin-right: 20px;
        }

        .header-title {
            position: relative;
            padding-left: 20px;
            text-align: left;
            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                height: 40px;
                transform: translateY(-50%);
                border-left: 1px solid #fff;
                opacity: .2;
            }
        }

        .header-right {
            margin-right: 0;
            .operate-btn.changeTheme {
                display: none;
            }
        }

    }

    .app-student-nav {
        position: fixed;
        top: 64px;
        width: 100%;
        background-color: #33363d;
        z-index: 7;
        box-shadow: 0 4px 12px rgba(38, 39, 52, 0.4);

        .nav-inner {
            display: flex;
        }

        .menu-list {
            position: relative;
            flex: 1;

            > a {
                position: relative;
                display: inline-block;
                height: 50px;
                line-height: 50px;
                padding: 0 20px;
                color: #fff;
                transition: all .3s;
                font-size: 16px;
                &:after {
                    content: '•';
                    position: absolute;
                    top: 15px;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 12px;
                    color: transparent;
                    text-shadow: transparent 0 0;
                    transition: all .3s;
                }

                &:hover {
                    color: $color-theme;
                    &:after {
                        color: #fff;
                        text-shadow: 10px 0 #fff, -10px 0 #fff;
                    }
                }

                &.router-link-active {
                    color: $color-theme;
                    &:before {
                        content: '';
                        position: absolute;
                        bottom: -12px;
                        right: 26px;
                        width: 0;
                        height: 0;
                        border-right: 20px solid transparent;
                        border-top: 18px solid #33363d;
                        border-left: 20px solid transparent;
                    }
                }
            }

        }

        .operate-btn {
            padding: 0 12px;
            line-height: 50px;
            cursor: pointer;

            .nucfont {
                color: #fff;
                outline: none;
            }

            &.changeTheme {
                display: block;
                outline: none;
            }
        }
    }

    .app-student-main {
        height: 100%;
        padding-top: 114px;

        .app-student-scroll {
            height: 100%;
            overflow-y: auto;
            background-color: #fff;
        }
    }
</style>
